import http from 'superagent'
import UserUtil from "../utils/UserUtil";
import RestService from "./RestService";

export default class UserService extends RestService {

    constructor() {
        super('users')
    }

    signUp(user, site) {

        let model = {
            user: {
                email: user.email,
                password: user.password,
                password_confirmation: user.password_confirmation,
                name: user.name,
                site: site
            }
        }

        if(user.invite_uuid) {
            model.user['invite_uuid'] = user.invite_uuid
        }

        if(user.app_id) {
            model.user['app_id'] = user.app_id
        }

        return new Promise((resolve, reject) => {
            http.post(this.baseUrl + '/api/v1/sign-up')
                .send(model)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        const user = JSON.parse(response.text);
                        resolve(user)
                    }
                    else {
                        reject(JSON.parse(response.text))
                    }

                })
        })
    }

    login(email, password, site) {
        const model = {
            user: {
                email: email,
                password: password,
                site: site
            }
        };

        return new Promise((resolve, reject) => {
            http.post(this.baseUrl + '/api/v1/login')
                .send(model)
                .set('Accept', 'application/json')
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        const user = JSON.parse(response.text);
                        resolve(user)
                    }
                    else {
                        reject(JSON.parse(response.text))
                    }

                })
        })
    }

    logout() {
        let authToken = webase.model.auth_token

        return new Promise((resolve, reject) => {
            http.get(this.baseUrl + '/api/v1/logout')
                .set('x-api-token', authToken)
                .end(function (error, response) {
                    if (response.status === 204) {
                        resolve()
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    permissions( appId ) {
        let authToken = webase.model.auth_token
        let url = this.baseUrl + '/api/v1/permissions.json'

        if(appId) {
            url = url + '?app_id=' + appId
        }

        return new Promise((resolve, reject) => {
            http.get(url)
                .set('x-api-token', authToken)
                .end(function (error, response) {

                    if (error) {
                        console.log('error')
                        console.log(error)
                        reject(error)
                        return
                    }

                    if (response.status === 200) {
                        const permissions = JSON.parse(response.text)
                        webase.model.permissions = permissions
                        resolve(permissions)
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    referrals() {
        let service = new RestService('users')
        let url = this.baseUrl + '/api/v1/users/referrals.json'
        return service.executeGet(url)
    }

    current() {
        let authToken = webase.model.auth_token

        return new Promise((resolve, reject) => {
            http.get(this.baseUrl + '/api/v1/users/current.json')
                .set('x-api-token', authToken)
                .end( (error, response) => {

                    if (error) {
                        console.log('error')
                        console.log(error)
                        reject(error)
                        return
                    }

                    if (response.status === 200) {
                        const user = JSON.parse(response.text)
                        webase.model.user_id = user.id
                        webase.model.currentUser = user
                        webase.utils.user = new UserUtil(user)
                        resolve(user)
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }
}